import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';

import { KYMW5002Component } from './kymw5002.component';

import { KYMW5002UseImageModule } from './kymw5002-use-image/kymw5002-use-image.module';
import { KYMW5002SearchResultModule } from './kymw5002-search-result/kymw5002-search-result.module';
import { KYMW5002ImageInfoDetailModule } from './kymw5002-image-info-detail/kymw5002-image-info-detail.module';
import { KYMW50registImageDataService } from './api-services/kymw50-regist-image-data.service';

/**
 * EC使用画像指示画面 モジュール設定クラス
 *
 * @export KYMW5002Module
 * @class KYMW5002Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    KYMW5002UseImageModule,
    KYMW5002SearchResultModule,
    KYMW5002ImageInfoDetailModule,
  ],
  declarations: [
    KYMW5002Component,
  ],
  providers: [
    KYMW50registImageDataService,
  ],
})
export class KYMW5002Module {

}
